<template>
    <template v-if="dataLoaded">
            <div class="back-route" @click.stop="router.go(-1)"><i class="material-icons">keyboard_arrow_left</i><span>Volver</span></div>
            <h1>{{ $t('course.modules.board.TITLE') }}</h1>
            <div class="muro__subtitle">
                <div></div>
                <span v-if="!courseIsFinished" @click="postEnabled = !postEnabled" ><i class="material-icons">question_answer</i> Publicar en el muro</span>
                <span v-else class="disabled" ><i class="material-icons">question_answer</i> Publicar en el muro</span>
            </div>
            <template v-if="(comments.length === 0 && !postEnabled && !courseIsFinished)">
                <EmptyState v-if="user.role.toLowerCase() === 'learninguser'" :icon="'insert_comment'" :message="'En breve tu facilitador inaugurará el muro del curso para que puedas participar.'" :title="'Todavía no hay comentarios en el muro'" />
                <EmptyState v-else  :icon="'insert_comment'" :color="'pink'" :message="'Anima a tu grupo a participar del muro del curso'" :title="'Todavía no hay comentarios en el muro'" />
            </template>
            <div v-else class="muro" ref="scrollComponent">
                <div class="muro__total-comments">
                    <i class="material-icons">groups</i>
                    <span>{{getDataDependencies.totalResults}} comentarios del muro</span>
                </div>
                <div v-if="courseIsFinished" class="courseIsFinished">
                    <i class="material-icons">check_circle</i>
                    <span>
                        <strong>Este curso ha finalizado</strong><br/>
                        <p>Podrás seguir visualizando las publicaciones del muro aunque ya no podrás participar.</p>
                    </span>
                </div>
                <div class="muro__newComment" :class="{'muro__newComment--activated': postEnabled}" >
                    <CommentBox v-if="postEnabled" @postComment="postBoardComment" :commentId="'newComment'" :index="index"  @discardComment="closeEditBox" :view="'board'" />
                </div>
                <template v-for="(header, index) in comments" :key="index">
                    <div class="muro__container">
                        <div class="muro__fatherComment">
                            <template v-if="!header.isDeleted">
                                <div class="user__info">
                                    <div class="user__info--user">
                                        <div class="user__avatar">
                                            <img v-if="header.userImage !== null" :src="getFile(header.userImage, 'user')" />
                                            <span v-else  :style="{backgroundColor: randomColor(header.userIdentifier)}" class="userImage__null">{{header.userName.charAt(0)}}</span>
                                        </div>
                                        <span class="user__info--name">
                                            <strong>{{header.userName}}</strong>
                                                - {{header.whenCreated.quantity}} {{$t(`date.params.${header.whenCreated.param}`)}}
                                        </span>
                                    </div>
                                    <div v-if="header.canEdit" class="dropdown" :ref="`user__info--name_${header.id}`">
                                        <input type="checkbox" :id="`user__info--name_${header.id}`">
                                        <label class="dropdown__face" :for="`user__info--name_${header.id}`">
                                            <span class="material-icons">more_horiz</span>
                                        </label>
                                        <ul class="dropdown__items">    
                                            <li class="material-icons" @click="modalIsOpen[index] = true" >delete</li>                                 
                                            <li class="material-icons" @click="editEnabled[index] = !editEnabled[index]" >edit</li>                                 
                                            <li class="material-icons" @click="closeOptions(`user__info--name_${header.id}`)" >close</li>                                 
                                        </ul>
                                    </div>
                                </div>
                
                                <div class="muro__content">
                                    <template v-if="!editEnabled[index]">
                                        <div v-html="header.comment"></div>
                                        <div class="muro__attach" v-if="header.attach.length">
                                            <template v-for="(att,idx) in header.attach" :key="idx">
                                                <a :href="getFile(att.file, 'foroComment')" target="_blank">
                                                    <img  class="muro__attach--img" v-if="att.contentType.includes('image')" :src="getFile(att.file,'foroComment')">
                                                </a>
                                                <div class="muro__attach__info">
                                                    <span class="muro__attach__info--name">{{att.originalFileName}}</span>
                                                    <span class="muro__attach__info--type">{{att.contentType}}</span>
                                                </div>
                                            </template>
                                            <template v-for="(att,idx) in header.attach" :key="idx">
                                                <a v-if="!att.contentType.includes('image')" :href="getFile(att.file,'foroComment')" target="_blank">
                                                    <i class="material-icons">attach_file</i><span>{{att.originalFileName}}</span>
                                                </a>
                                            </template>
                                        </div>
                                    </template>
                                    <CommentBox v-else @postComment="editComment" :commentId="header.id" :content="header" :index="index"  @discardComment="closeEditBox" :view="'board'" />
                                </div>
                            </template>
                            <template v-else >
                                <div class="muro__deleted">
                                    <div class="muro__deleted--message">
                                        <i class="material-icons-outlined">error_outline</i>
                                        <span>El comentario ha sido eliminado</span>
                                    </div>
                                    <div v-if="user.permissions.includes('CURSO_FORO_TEMA_DEBATE')" class="dropdown" :ref="`user__info--name_${header.id}`">
                                        <input type="checkbox" :id="`user__info--name_${header.id}`">
                                        <label class="dropdown__face" :for="`user__info--name_${header.id}`">
                                            <span class="material-icons">more_horiz</span>
                                        </label>
                                        <ul class="dropdown__items--deleted">    
                                            <li class="material-icons" @click="modalIsOpen[index] = true" >delete</li>                                 
                                            <li class="material-icons" @click="closeOptions(`user__info--name_${header.id}`)" >close</li>                                 
                                        </ul>
                                    </div>
                                </div>
                            </template>
                            
                            <div class="muro__actions" v-if="!header.isDeleted">
                                <template v-if="!header.isDeleted">
                                    <button :disabled="courseIsFinished" class="actions--btn" :class="{'liked': header.isLikedByUser}" @click="likeUnlikeHeader(index)">
                                        <i class="material-icons">favorite_border</i> {{$t('forum.actions.LIKE')}} ({{header.likesQuantity}})
                                    </button>
                                    <button :disabled="courseIsFinished" class="actions--btn" @click="commentBoxOpened[index] = commentBoxOpened[index] === undefined ? true : !commentBoxOpened[index]" :class="{'activated' : commentBoxOpened[index]} ">
                                        <i class="material-icons-outlined">comment</i> 
                                        Comentar ({{header.repliesQuantity}})
                                    </button>
                                </template>
                            </div>
                            <template v-if="commentBoxOpened[index]">
                                <CommentBox @postComment="postComment" :commentId="header.id" @discardComment="closeEditBox" :index="index" :view="'board'" />
                            </template>
                            <div class="muro__comments">

                                <span v-if="header.repliesQuantity === 0" class="muro__comments--viewMore" >No hay respuestas aún</span>
                                <span v-else-if="!commentsOpened[index]" class="muro__comments--viewMore" @click="getComments(header.id, index); commentsOpened[index] = true " >Ver todas las respuestas ({{header.repliesQuantity}})</span>
                                <template v-else-if="commentsOpened[index]">
                                    <span class="muro__comments--viewMore" @click="commentsOpened[index] = false " >Ocultar las respuestas</span>
                                    <template v-for="(comment, cindex) in header.replies" :key="cindex">
                                        <Comment :courseIsFinished="courseIsFinished" :data="comment" @editComment="editComment" :index="index" @discardComment="closeEditBox" @liked="likeUnlikeComment" @deleteComment="deleteComment"/>
                                    </template>
                                    <span v-if="header.totalRepliesLoaded < header.totalReplies" class="comment__loadMore" :class="{'loading': !commentsLoaded}" @click.stop="commentsLoaded && getComments(header.id, index)" >Cargar mas respuestas</span>
                                </template>
                            </div>
                        </div> <!-- muro__container -->
                    </div>
                    <!-- MODAL DELETE COMMENT -->
                    <Modal v-if="modalIsOpen[index]" :isOpen="modalIsOpen[index]" @close="toggleModal(index)" @keyup.esc="toggleModal" >
                        <div class="modal__content">
                            <div class="modal__title">
                                <h2>{{ $t('comments.WISH_DELETE_COMMENT') }}</h2>
                                <p>Puedes borrar unicamente el comentario, como asi tambien el hilo completo.</p>
                            </div>
                            <div class="modal__options">
                                <!-- <button class="modal__options--cancel" @click="toggleModal(index)" >{{$t('global.CANCEL')}}</button> -->
                                <button v-if="!header.isDeleted" class="modal__options--deleteOnly" @click.stop="deleteComment(header.id, index); toggleModal(index);">{{ $t('comments.DELETE_COMMENT') }}</button>
                                <button v-if="header.repliesQuantity > 0" class="modal__options--deleteAll" @click.stop="deleteComment(header.id, index, null, true); toggleModal(index);">Borrar hilo</button>
                            </div>
                        </div>
                    </Modal>
                    <!-- ----------- -->

                </template>
                <Loader v-if="!newDataLoaded" />
            </div>

    </template>
    <template v-else>
        <Loader />
    </template>
</template>

<script>
    import EmptyState from '../components/EmptyState.vue';
    import Comment from '../components/Comments/Comment.vue'
    import { computed, inject, onMounted, onUnmounted, ref } from 'vue';
    import { useRoute, useRouter } from "vue-router";
    import { useStore } from 'vuex';
    import CommentBox from '../components/Comments/CommentBox.vue';
    import Loader from '../components/Loader.vue';
    import Modal from '../components/Modal.vue'
    
    
    export default {
        
        components:{
            EmptyState,
            Comment,
            CommentBox,
            Loader,
            Modal
        },
        setup() {
            const getFile = inject("getFile");
            const comments = ref(false)
            // const router = useRouter();
            const route = useRoute();
            const store = useStore();
            const router = useRouter();
            const user = computed(() => store.getters.manageUser_user);
            const commentActivate = ref(false);
            const dataLoaded = ref(false)
            const commentsLoaded = ref(false);
            const newDataLoaded = ref(true)
            const headerId = ref()
            const commentsOpened = ref([])
            const commentBoxOpened = ref([])
            const editEnabled = ref([])
            const commentEditedLoaded = ref(false)
            const commentLikeLoaded = ref(false)
            const courseIsFinished = ref()
            const postEnabled = ref(false)
            const modalIsOpen = ref([])
            const userLeterColors = ['#ff6961','#77dd77','#d2bead','#84b6f4','#fdcae1', '#9bd3ae', '#a0d2f3', '#a788ab', '#bf9780', '#96c4c4', '#5086c1', '#bdbfbf'];
            const getDataDependencies = ref({
                totalResults: 1,
                totalResultsLoaded: 0,
                pageNumber: 0
            }) 
            const getCommentsDependencies = ref({
                totalResults: 1,
                totalResultsLoaded: 0,
                pageNumber: 0,
                lastCommentFather: undefined
            }) 
            const scrollComponent = ref(null)

            const getData = async () => {
                let props = {
                    coursesId: route.params.courseId,
                    pageNumber: getDataDependencies.value.pageNumber,
                    rowsPerPage: 10,
                }
                if(getDataDependencies.value.pageNumber === 0) dataLoaded.value = false 
                if(getDataDependencies.value.totalResultsLoaded < getDataDependencies.value.totalResults){
                    newDataLoaded.value = false
                    let res = await store.dispatch('courses_board', props)
                    courseIsFinished.value = res.data.courseIsFinished
                    newDataLoaded.value = true
                    !comments.value ? comments.value = res.data.comments : comments.value.push(...res.data.comments)
                    getDataDependencies.value.totalResults = res.data.totalResults
                    getDataDependencies.value.totalResultsLoaded = comments.value.length
                    getDataDependencies.value.pageNumber++
                    headerId.value = res.data.header.id
                    dataLoaded.value = true
                }
            }

            const getComments = async (id, index) => {
                commentsLoaded.value = false
                let props = {
                    courseId: route.params.courseId,
                    commentId: id,
                    pageNumber: comments.value[index].pageNumber ? comments.value[index].pageNumber : 0,
                    rowsPerPage: 5,
                }
                if(!comments.value[index].pageNumber || comments.value[index].totalRepliesLoaded < comments.value[index].totalReplies){
                    let res = await store.dispatch('forum_commentAnswers',props)
                    !comments.value[index].replies ? comments.value[index].replies = res.data.data : comments.value[index].replies.push(...res.data.data)
                    comments.value[index].totalReplies = res.data.totalResults
                    comments.value[index].totalRepliesLoaded = comments.value[index].replies.length
                    comments.value[index].pageNumber ?  comments.value[index].pageNumber++ : comments.value[index].pageNumber = 1
                    getCommentsDependencies.value.lastCommentFather = id
                    commentsLoaded.value = true
                }
            }
                    
            async function postBoardComment(req) {
                let comment = {
                    ...req
                }
                try {
                    let request = {
                        courseId: route.params.courseId,
                        req: comment
                    } 
                    let res = await store.dispatch('courses_board_comment',request);
                    comments.value.splice(0, 0, res.data)  //Inserta en el primer lugar del array el nuevo comentario           
                    getDataDependencies.value.totalResults++
                    postEnabled.value = false
                } catch (error) {
                    console.log(error);
                    store.dispatch("notifications_create", {text: "Error al enviar comentario"});
                }
            }

            const postComment = async (comment) => {
                let request = {
                    ...comment,
                    courseId: route.params.courseId,
                    savingEdition: true,
                    forumHeaderId: headerId.value
                }
                try {
                    let req = await store.dispatch('forum_postComment',request);
                    if('replies' in comments.value.find(com => com.id == request.relatedCommentId)){
                        comments.value.find(com => com.id == request.relatedCommentId).replies.splice(0,0, req.data)
                    }
                    comments.value.find(com => com.id == request.relatedCommentId).repliesQuantity++;
                    commentBoxOpened.value[comments.value.findIndex(com => com.id == request.relatedCommentId)] = false
                } catch (error) {
                    console.log(error);
                    store.dispatch("notifications_create", {text: "Error al enviar comentario"});
                }
            }

            async function likeUnlikeHeader(index){
                if(commentLikeLoaded.value) return
                commentLikeLoaded.value = true
                try {
                    if(comments.value[index].isLikedByUser){
                    await store.dispatch('forum_deleteLikeComment',comments.value[index].id);
                    comments.value[index].isLikedByUser = false;
                    comments.value[index].likesQuantity--;
                    }
                    else{
                    await store.dispatch('forum_postLikeComment',comments.value[index].id);
                    comments.value[index].isLikedByUser = true;
                    comments.value[index].likesQuantity++;
                    }
                    commentLikeLoaded.value = false
                } catch (error) {
                    console.log(error)
                    store.dispatch('notifications_create',{text:'Error al likear'})
                    commentLikeLoaded.value = false
                }
            }

            async function editComment(newComment, index){
                if(commentEditedLoaded.value) { return }
                commentEditedLoaded.value = true
                // let oldComment = comments.value.find(comm => comm.id === newComment.id) === undefined ? comments.value[index].replies.find(comm => comm.id === newComment.id) : comments.value.find(comm => comm.id === newComment.id)
                try{
                    // comment.comment = newComment.message
                    await store.dispatch('forum_editComment', newComment)
                    if(comments.value.find(comm => comm.id === newComment.id) === undefined ){
                        comments.value[index].replies.find(comm => comm.id === newComment.id).comment = newComment.comment
                        comments.value[index].replies.find(comm => comm.id === newComment.id).attach = newComment.attach
                    }
                    else{
                        comments.value.find(comm => comm.id === newComment.id).comment = newComment.comment
                        comments.value.find(comm => comm.id === newComment.id).attach = newComment.attach
                    }
                    editEnabled.value[index] = false
                    commentEditedLoaded.value = false
                }catch (error) {
                    console.log(error)
                    store.dispatch('notifications_create',{text:'Error al editar comentario'})
                }
            }

            const likeUnlikeComment = (id, like, index) => {
                let commentIndex = comments.value[index].replies.findIndex(comment => comment.id === id)                
                if (like){
                    comments.value[index].replies[commentIndex].isLikedByUser = true;
                    comments.value[index].replies[commentIndex].likesQuantity++;
                }
                else{
                    comments.value[index].replies[commentIndex].isLikedByUser = false;
                    comments.value[index].replies[commentIndex].likesQuantity--;
                }
            }

            const toggleModal = (index) => modalIsOpen.value[index] = !modalIsOpen.value[index]

            const deleteComment = async (id, index, fromComment=null, all=false) => {
                /* 
                    All = Si es true, se borrara el hilo completo en caso de tener comentarios hijos relacionado al mismo
                    fromComment = si es diferente a null, la funcion se utilizara para eliminar un comentario hijo.
                */
               let params = {
                commentId: id,
                courseId: route.params.courseId,
                fullDelete: all
               }
                try{
                    await store.dispatch('courses_board_deleteComment', params)
                    if(fromComment !== null){
                        let ind = comments.value[index].replies.findIndex(com => com.id === id)
                        comments.value[index].replies.splice(ind, 1)
                        comments.value[index].repliesQuantity--
                    }else if(all){
                        comments.value.splice(index, 1)
                        getDataDependencies.value.totalResults--
                    }
                    else{
                        comments.value[index].isDeleted = true
                    }
                } catch (err){
                    console.log(err)
                    store.dispatch('notifications_create',{text:'Error al intentar eliminar comentario'})
                }
            }

            const closeOptions = (id) => document.getElementById(id).checked = false

            const closeEditBox = index => {
                commentBoxOpened.value[index] = false
                postEnabled.value = false
                editEnabled.value[index] = false
            }

            const handleScroll = () => {
                if(newDataLoaded.value){
                    let element = scrollComponent.value
                    if(element.getBoundingClientRect().bottom - 1 < window.innerHeight){
                        getData()
                    }
                }
            }

            const randomColor = (seed)  => {
                seed = (seed || '') + "xx";
                var charCodes = seed.split('').reduce(function(a, b, i) {
                    return (i == 1 ? a.charCodeAt(0) : +a) + b.charCodeAt(0);
                });
                return userLeterColors[charCodes % userLeterColors.length]
            }

            onMounted(() => {
                getData()
                window.addEventListener('scroll', handleScroll)
            })

            onUnmounted(() => {
                window.removeEventListener('scroll', handleScroll)
            })

            return {
                comments,
                getFile,
                getData,
                commentActivate,
                dataLoaded,
                postComment,
                getComments,
                postBoardComment,
                commentsOpened,
                commentBoxOpened,
                likeUnlikeHeader,
                closeOptions,
                getDataDependencies,
                user,
                editEnabled,
                editComment,
                postEnabled,
                closeEditBox,
                likeUnlikeComment,
                modalIsOpen,
                toggleModal,
                deleteComment,
                scrollComponent,
                newDataLoaded,
                commentsLoaded,
                getCommentsDependencies,
                randomColor,
                router,
                courseIsFinished
            }
        },
    }
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

*{
    color: $black;
}

.courseIsFinished{
    margin: 12px 0;
}

.back-route{
    width: fit-content;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    cursor: pointer;
    span{
        color: $green;
    }
    .material-icons{
        font-size: 17px;
        color: $green;
    }
}

h1{
    font-weight: 700;
    font-size: 22px; 
    padding: 14px 0;
}
h4{
    font-weight: 600;
    font-size: 18px;
}

.activated{
    color: $green;
    i{
        color: $green;
    }
}
.dropdown{
    width: fit-content;
    &__face{
        padding: 0;
        border-radius:0;
        border: none;
        width: fit-content
    }
    &__items, &__items--deleted{
        top: 0;
        left: 100%;
        flex-direction: row;
        width: 0;
        padding:0;
        visibility: hidden;
        li{
            font-size: 0px;
        }
    }
    input {
        display: none;
        &:checked ~ .dropdown__items {
        top: calc(100% + -28px);
        visibility: visible;
        left: -420%;
        padding: 10px;
        width: fit-content;
        opacity: 1;
        li{
            font-size: 17px;
        }
        }
        &:checked ~ .dropdown__items--deleted {
            top: calc(100% + -28px);
            visibility: visible;
            left: -270%;
            padding: 10px;
            width: fit-content;
            opacity: 1;
            li{
                font-size: 17px;
            }
        }
    }
}
.user{
    &__info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        width: 100%;
        &--user{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 12px;
        }
        &--name{
            color: $darkgray;
            font-weight: 400;
            font-size: 14px;
            strong{
                color: $black;
                font-weight: 600;
                font-size: 16px;
                @media screen and (max-width : $bpBig){
                    font-size: 14px
                }
            }
        }
    }
    &__avatar{
        position: relative;
        width: 45px;
        height: 45px;
        border-radius: 100%;
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        &--null{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            color: #fff;
            background-color: $green;
        }
    }
}

.muro{
    padding: 30px 0;
    border-top: 1px solid $whitegray;
    &__loadMore{
        width: 100%;
        display: flex;
        justify-content: center;
        color: $green;
        cursor: pointer;
        font-weight: 700;
    }
    &__deleted{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        position: relative;
        overflow: visible;
        &--message{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            .material-icons-outlined{
                color: $darkgray;
                font-size: 24px;
            }
            span{
                color: $darkgray;
            }
        }
        .dropdown{
            right: 0;
            position: absolute;
        }
    }
    &__subtitle{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 27px 0;
        span{
            color: $green;
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 14px;
            gap: 6px;
            @media screen and (max-width : $bpBig){
                position: fixed;
                width: 100%;
                background-color: $green;
                bottom: 0;
                color: #ffff;
                left: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 26px 0;
                z-index: 100;
            }
            cursor: pointer;
            i{
                color: $green;
                font-weight: 600;
                font-size: 18px;
                @media screen and (max-width : $bpBig){
                    color: #fff;
                }
            }
            &.disabled{
                cursor: default;
                opacity: .4;
            }
        }
    }
    &__total-comments{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        width: fit-content;
        span{
            font-weight: 600;
            font-size: 14px;
        }
    }
    &__container{
        margin: 20px 0;
        padding: 24px 40px;
        border: 1px solid $lightgray;
        border-radius: 10px;
        @media screen and (max-width: $bpBig){
            padding: 24px 14px;
        }
    }
    &__fatherComment{
        display: flex;
        flex-direction:column;
        justify-content:center;
        align-items: flex-start;
        gap: 24px;
    }
    &__actions{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 32px;
        width: 100%;
        box-sizing: content-box;
        padding: 24px 0 20px 0;
        border-top: 1px solid $lightgray;
        border-bottom: 1px solid $lightgray;

        .liked{
            color: $green;
            i{
                color: $green;
            }
        }
        .actions--btn{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            font-size: 14px;
        }
        button:disabled{
            opacity: .4;
            cursor: default;
        }
    }
    &__content{
        width: 100%;
        >div{
            overflow-wrap: anywhere;
        }
    }
    &__comments{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 48px;
        padding-right: 18px;
        width: 100%;
        &--viewMore{
            width: 100%;
            text-align: center;
            color: $green;
            cursor: pointer;
        }
    }
    &__attach{
            display: flex;
            gap: 6px;
            align-items: center;
            a{
                display: flex;
                align-items: center;
            }
        &--img{
            width: 100%;
            max-width: 260px;
            height: 100%;
            max-height: 180px;
            border-radius: 10px;
        }
        &__info{
            display: flex;
            flex-direction: column; 
            &--name{
                font-weight: 600;
                font-size: 14px;
                color: $green;
            }
            &--type{
                font-weight: 400;
                font-size: 14px;
                color: $darkgray;
            }
        }
    }
    &__newComment{
        @media screen and (max-width: $bpBig){
            position: fixed;
            background: #fff;
            z-index: 100;
            bottom: 72px;
            left: 0;
            box-shadow: 0px -1px 11px #00000040;
            width: 100%;
            &--activated{
                padding: 10px;
            }
        }
    }
}

.modal{
    &__content{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
    }
    &__title{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 18px;
        p{
            font-size: 14px;
            text-align: center;
        }
        h2{
            font-size: 20px;
            font-weight: 700;
            text-align: center;
        }
        i{
            color: $green;
            padding: 8px;
            font-size: 20px;
            background-color: rgba($color: $green, $alpha: .3);
            border-radius: 999px;
        }
    }
    &__options{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 18px;
        @media screen and (max-width: $bpSmall){
            flex-direction: column;
            gap: 6px;
        }
        &--deleteAll{
            font-weight: 4s00;
            font-size: 16px;
            color: #fff;
            background-color: $green;
            padding: 12px 24px;
            border-radius: 44px;
            width: 180px;
        }
        &--deleteOnly{
            font-weight: 400;
            font-size: 16px;
            color: $green;
            background-color: inherit;
            border: 1px solid $green;
            padding: 12px 24px;
            border-radius: 44px;
            width: 180px;
        }
        &--cancel{
            font-weight: 600;
            font-size: 16px;
            color: $black;
        }
    }
}

.comment{
    &__loadMore{
        display: flex;
        justify-content: center;
        width: 100%;
        color: $green;
        cursor: pointer;
    }
}

.loading{
    cursor: default;
    color: $darkgray;
}


</style>